import React, {FC} from "react"
import './CheckBox.less'

interface Props {
    label: string
    value: boolean
    setValue: (value: boolean) => void
    className?: string
}

export const CheckBox: FC<Props> = ({
    label,
    value,
    setValue,
    className,
}) => {
    const handleClick = () => {
        setValue(!value)
    }

    const classes = ['checkbox-container']
    if (className) {
        classes.push(className)
    }

    return (
        <label className={classes.join(' ')}>
            <input
                type="checkbox"
                checked={value}
                onChange={handleClick}
                className="checkbox-input"
            />
            <span className="checkbox-custom"></span>
            <span className="checkbox-label">{label}</span>
        </label>
    )
}
